/* Luzzart · Menu desktop v5: abre/fecha os painéis (snippets/lz-mega.liquid). Sem dependências.
   Mouse: abre depois de 120 ms (trocar de item com um painel aberto é na hora); fecha 180 ms depois de sair do cabeçalho.
   Clique/Enter/Espaço alterna; Esc fecha e devolve o foco ao item; Tab entra no painel aberto e sair da barra fecha.
   Toque (iPad): o 1º toque abre o painel; Luminárias: passar o mouse ou focar numa categoria troca as colunas 2 e 3. */
(function () {
  'use strict';
  function hydrateImage(im) {
    var srcset = im.getAttribute('data-lz-srcset');
    var src = im.getAttribute('data-lz-src');
    if (srcset) { im.setAttribute('srcset', srcset); im.removeAttribute('data-lz-srcset'); }
    if (src) { im.setAttribute('src', src); im.removeAttribute('data-lz-src'); }
    im.loading = 'eager';
  }

  var OPEN_DELAY = 120, CLOSE_DELAY = 180;

  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function init(root) {
    if (root.getAttribute('data-lzg-ready')) return;
    root.setAttribute('data-lzg-ready', '1');
    var nav = root.closest('#main_navwr') || root;
    var items = qa('[data-lzg-item]', root).filter(function (li) { return q('[data-lzg-toggle]', li); });
    var scrim = q('[data-lzg-scrim]', root);
    if (scrim && scrim.parentNode !== document.body) document.body.appendChild(scrim); // o cabeçalho fixo tem transform e prenderia o fundo dentro dele
    var hover = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)').matches : true;
    var openLi = null, tOpen = 0, tClose = 0, touchOpened = false;

    function panelOf(li) { return q('[data-lzg-panel]', li); }
    function btnOf(li) { return q('[data-lzg-toggle]', li); }
    function placeScrim() {
      if (scrim) scrim.style.top = Math.max(0, Math.round(nav.getBoundingClientRect().bottom)) + 'px';
    }
    function open(li) {
      clearTimeout(tClose);
      if (openLi === li) return;
      if (openLi) close(openLi, true);
      openLi = li;
      // só as imagens à vista (as colunas 2 e 3 das outras categorias carregam quando forem escolhidas)
      qa('img[loading="lazy"]', panelOf(li)).forEach(function (im) { if (!im.closest('[data-lzg-det][hidden]')) hydrateImage(im); });
      var first = q('[data-lzg-cat]', panelOf(li));
      if (first) selectCat(first, true);
      panelOf(li).hidden = false;
      btnOf(li).setAttribute('aria-expanded', 'true');
      placeScrim();
      // em janela baixa o painel rola por dentro (a faixa "Sem ponto de luz?" não é cortada)
      panelOf(li).style.maxHeight = Math.max(240, Math.round(window.innerHeight - panelOf(li).getBoundingClientRect().top - 8)) + 'px';
      if (scrim) scrim.hidden = false;
    }
    function close(li, switching) {
      panelOf(li).hidden = true;
      btnOf(li).setAttribute('aria-expanded', 'false');
      if (openLi === li) openLi = null;
      if (!switching && scrim) scrim.hidden = true;
    }
    function closeAll() { clearTimeout(tOpen); clearTimeout(tClose); if (openLi) close(openLi); }

    items.forEach(function (li) {
      var btn = btnOf(li);
      li.addEventListener('mouseenter', function () {
        if (!hover) return;
        qa('img[loading="lazy"]', panelOf(li)).forEach(function (im) { if (!im.closest('[data-lzg-det][hidden]')) hydrateImage(im); });
        clearTimeout(tClose); clearTimeout(tOpen);
        tOpen = setTimeout(function () { open(li); }, openLi ? 0 : OPEN_DELAY);
      });
      li.addEventListener('mouseleave', function () { clearTimeout(tOpen); });
      btn.addEventListener('pointerdown', function (e) { touchOpened = e.pointerType === 'touch' && openLi !== li; });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(tOpen);
        if (touchOpened) { touchOpened = false; open(li); return; }
        if (openLi === li) close(li); else open(li);
      });
    });
    // teclado: o foco que sai da barra fecha o painel; o foco que vai para outro item da barra fecha o anterior
    nav.addEventListener('focusout', function (e) {
      if (openLi && e.relatedTarget && !nav.contains(e.relatedTarget)) closeAll();
    });
    nav.addEventListener('focusin', function (e) {
      if (openLi && !openLi.contains(e.target)) close(openLi);
    });
    // passar o mouse em um item sem painel (Natal, Mais vendidos) fecha o painel aberto, como no protótipo
    qa('.lzg-bar > li:not([data-lzg-item])', root).forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        if (!hover) return;
        clearTimeout(tOpen); clearTimeout(tClose);
        tClose = setTimeout(closeAll, CLOSE_DELAY);
      });
    });
    // fechar: sair do cabeçalho (barra + painéis), clicar fora ou no fundo, Esc
    nav.addEventListener('mouseenter', function () { clearTimeout(tClose); });
    nav.addEventListener('mouseleave', function () {
      if (!hover) return;
      clearTimeout(tOpen);
      tClose = setTimeout(closeAll, CLOSE_DELAY);
    });
    if (scrim) {
      // mousemove (não mouseenter): o fundo aparece sob um mouse parado quando o menu abre pelo teclado, e isso não deve fechar
      scrim.addEventListener('mousemove', function () { if (hover) closeAll(); });
      scrim.addEventListener('click', closeAll);
    }
    document.addEventListener('click', function (e) { if (openLi && !nav.contains(e.target) && e.target !== scrim) closeAll(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !openLi) return;
      var li = openLi, had = li.contains(document.activeElement);
      close(li);
      if (had) btnOf(li).focus();
    });
    var lastY = window.pageYOffset;
    window.addEventListener('scroll', function () {
      if (!openLi) { lastY = window.pageYOffset; return; }
      if (Math.abs(window.pageYOffset - lastY) > 60) closeAll();
    }, { passive: true });
    window.addEventListener('resize', function () { if (openLi) placeScrim(); });

    // Luminárias: categoria em foco ou sob o mouse mostra as colunas 2 e 3 dela (sem buscar nada, só troca o hidden)
    var cats = qa('[data-lzg-cat]', root);
    function selectCat(a, quiet) {
      var id = a.getAttribute('data-lzg-cat');
      cats.forEach(function (c) {
        var on = c === a;
        c.classList.toggle('is-on', on);
        c.setAttribute('tabindex', on ? '0' : '-1');
      });
      qa('[data-lzg-det]', root).forEach(function (d) {
        var show = d.getAttribute('data-lzg-det') === id;
        if (show) { qa('img[loading="lazy"]', d).forEach(function (im) { hydrateImage(im); }); }
        d.hidden = !show;
      });
    }
    cats.forEach(function (a, i) {
      a.addEventListener('mouseenter', function () { if (hover) selectCat(a); });
      a.addEventListener('focus', function () { selectCat(a); });
      // setas trocam de categoria (só a escolhida fica na ordem de Tab; o Tab seguinte entra nas colunas 2 e 3)
      a.addEventListener('keydown', function (e) {
        var to = null;
        if (e.key === 'ArrowDown') to = cats[Math.min(i + 1, cats.length - 1)];
        else if (e.key === 'ArrowUp') to = cats[Math.max(i - 1, 0)];
        else if (e.key === 'Home') to = cats[0];
        else if (e.key === 'End') to = cats[cats.length - 1];
        if (!to) return;
        e.preventDefault();
        selectCat(to);
        to.focus();
      });
      a.addEventListener('click', function (e) {
        if (!hover && !a.classList.contains('is-on')) { e.preventDefault(); selectCat(a); }
      });
    });
  }

  function boot() { qa('[data-lzg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
